export default {
  // Configuración general de la tienda (uso común)
  storeSettings: {
    logoType: 'square', // Personalización para torzo
    storeName: 'torzo',
    currency: 'MXN',
    language: 'es',
    timezone: 'America/Mexico_City'
  },
  
  // Configuración específica del componente Cart
  Cart: {
    // Campos obligatorios en el formulario de pedido
    requiredFields: {
      nombre: true,
      email: false,
      telefono: true,
      direccion: true, // Solo obligatorio si es delivery
    },
    
    // Opciones de entrega disponibles
    deliveryOptions: [
      {
        id: 'Envio',
        label: 'Envío Gratis a domicilio',
        price: 0, // Precio en centavos o la unidad que uses
        default: false
      },
      {
        id: 'Recoger',
        label: 'Recoger Gratis en tienda',
        price: 0,
        default: true
      }
    ],
    
    // Configuración de métodos de pago
    paymentMethods: [
      {
        id: 'efectivo',
        label: 'Efectivo',
        default: true
      },
      {
        id: 'transferencia',
        label: 'Transferencia bancaria',
        default: false
      }
    ],
    
    // Configuración de opciones de pago
    paymentOptions: {
      showOnlinePayment: false, // Activar/desactivar pago en línea
      showCashPayment: true,    // Activar/desactivar pago en efectivo
      showBankTransfer: true,   // Activar/desactivar transferencia bancaria
      showOtherPayment: true    // Activar/desactivar otros métodos (PayPal/Mercado Pago)
    }
  },
  
  // Configuración específica del componente Navbar
  Navbar: {
    showSearch: true,
    showCart: true,
    showProfile: true,
    logoPosition: 'left' // 'left', 'center', 'right'
  },
  
  ClienteAuth: {
    phonePrefix: '+52-',      // Prefijo fijo visible en el input
    phoneMask: 'XX-XXXX-XXXX', // Máscara después del prefijo (X = dígito)
  },

  // Configuración específica del componente Products
  Products: {
    itemsPerPage: 12,
    showFilters: true,
    showSorting: true,
    gridColumns: 3 // Número de columnas en la grilla
  },
  
  // Configuración específica del componente Footer
  Footer: {
    showSocialMedia: true,
    showContactInfo: true,
    showNewsletter: false
  },
  
  // Configuración del catálogo
  HomeCategory: {
    homeClassic: false,
  },

  // Configuración del catálogo
  Catalog: {
    showCategoryMenu: true,      // Mostrar menú inicial de categorías en móvil
    enableCatalogView: false,    // Desactivar vista de catálogo (usar vista normal en móvil)
    showCategories: true,
    showFilters: true,
    hasWave: false,
    itemsPerPage: 20,
    gridColumns: 4,
    showAllProductsButton: true, // Mostrar botón "Ver Todos los Productos" al final del catálogo
    fullCatalogButton: {
      variant: 'torzo-pill',
      applyMetallicTitle: true,
      text: 'CATÁLOGO COMPLETO AQUÍ',
      bgStart: '#ff3535',
      bgEnd: '#b70000',
      borderColor: '#ff9a5f',
      textColor: '#ffffff',
      iconColor: '#ffffff',
      textShadow: '0 2px 6px rgba(0, 0, 0, 0.45)',
      shadow: '0 10px 20px rgba(145, 0, 0, 0.35), inset 0 1px 0 rgba(255,255,255,0.32)',
      radius: '999px',
      padding: '14px 26px',
      fontSize: '2rem',
      letterSpacing: '0.5px',
      maxWidth: '470px',
    },
  }
};